export default __webpack_public_path__ + "static/media/android-s1-cn.fdfb33d7.webp";